module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAvCAYAAADw46qXAAABB0lEQVRYhe3WQUrDQAAF0Gfpolo9SQXBnVirru0dRLBn0BuI9TjtBRTEjbjSE0jrWi+gCycQi45JSFzY+TCLzB/mJZAJWTm7f1ciPVzgIFxf4xxPRTdol8TusJGbGwZ8B49FNmmVAK8WsCzrGBfdpAy4X7GrDK5V7CqDtSSBCVxesIcJXsOYhLlS39Ki2cIturm5IQ7Rb+IJxwtYli4umwD3It2gCXA10nX+zVuaQJuY4i2MaZirPW1s48bXs3Pk8+dogIc6wZZfDmqdWAbuRvp+E2An0se6yuCfJoEJTGACE5jABC4LOIv0+e45su6l6LoWRph/U85Dl+X0h5ub4Th3PYqsO/kAyTMmFLawe1kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/riskassessactive.png
// module id = l7Ol
// module chunks = 1